import { createStore } from "vuex";
//创建存储对象
export default createStore({
  state: {
    page: [],
  },
    // 在其他视图中通过 $store.commit('setState', 10) 使用，用于修改stor存的值
    mutations: {
      setState(state, obj) {// 只能接受两个参数，用于修改store存的值
        state.page.push(obj);
      },
    },
    // 相当于组件的计算属性 通过 $store.getters.doubleCount 获取计算后的值
    // store的下级store 方便大型项目复杂数据管理，这里面相当于可以在放置一个和外面这些一样的模块
    modules: {},
});